const Tabs = ({ t, setTab, tab }) => {
  const tabs = [
    {
      name: t("generalSettings"),
      value: "general",
    },
    {
      name: t("accountSettings"),
      value: "account",
    },
    {
      name: t("notifications"),
      value: "notifications",
    },
  ];
  return (
    <section className="grid bg-[#182443] grid-cols-1 my-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
      {tabs.map((t, i) => {
        const active = t.value === tab;

        return (
          <button
            className={` border-b text-center py-4 font-semibold ${
              active ? "text-white border-white" : "text-primary border-transparent"
            }`}
            onClick={() => setTab(t.value)}
            key={i}
          >
            {t.name}
          </button>
        );
      })}
    </section>
  );
};

export default Tabs;
